import React, { Component } from 'react';
import { Row, Col, Button, Container, FormGroup, Form, FormFeedback, Input } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha';

import {entityGet, entityPost} from '../entity/Entity';
import { run, validationRunner } from '../validation/validationRunner'
import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import *  as Actions from '../registration/RegisterActions';
import Loading from '../app/Loading';
import MissingPrivacyStatement from './MissingPrivacyStatement'
import DataFetchError from './DataFetchError';

import RegistrationFormPersonData from './RegistrationFormPersonData';
import RegistrationFormAddressData from './RegistrationFormAddressData';
import RegistrationForCommData from './RegistrationFormCommData';
import RegistrationFormFinancialData from './RegistrationFormFinancialData'
import RegistrationFormActivityData from './RegistrationFormActivityData'
import RegistrationFormFreeFieldData from './RegistrationFormFreeFieldData'
import SubmitFailure from './SubmitFailure';
import ConfirmNoSports from './ConfirmNoSports';
import RegistrationSuccess from './RegistrationSuccess'

const fieldValidations = [

  validationRunner("Remarks", "Opmerkingen", Validations.maxLength(1024)),
  validationRunner("Captcha", "Captcha", Validations.required),
]


class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      minor: false,
      isUnionMember: false,
      confirmNoSports: false,
      validationErrors: [],
      fieldsTouched: [],
      Remarks: "",
      Captcha: "",
    };

    this.getCountries();
    this.getNationalities();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setIsMinor = this.setIsMinor.bind(this);
    this.setIsUnionMember = this.setIsUnionMember.bind(this);
    this.clearSubmitFailure = this.clearSubmitFailure.bind(this);

    this.handleChange = FormLogic.handleChange.bind(this);
    this.handleChangeToUpper = FormLogic.handleChangeToUpper.bind(this);
    this.handleChangeCapitalizeWords = FormLogic.handleChangeCapitalizeWords.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.run = run.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
  }


  setIsMinor(isMinor){
    this.setState({minor: isMinor});
  }

  setIsUnionMember(isUnionMember){
    this.setState({isUnionMember: isUnionMember});
  }

  onCaptchaChange(response) {
    this.setState({'Captcha': response});
  }


  clearSubmitFailure() {
    this.setState({'Captcha': ""});
    window.grecaptcha.reset();
    this.props.clearSubmitFailure()
  }


  componentDidUpdate() {
    this.run(fieldValidations);
  }


  getCountries() {
    this.props.fetchingCountries()
    entityGet("CountryCodes", {}, this.props.fetchCountriesSuccess, this.props.fetchCountriesFailure);
  }

  getNationalities() {
    this.props.fetchingNationalities()
    entityGet("Nationalities", {}, this.props.fetchNationalitiesSuccess, this.props.fetchNationalitiesFailure);
  }



  getFormValues() {
    const baseData =  {
      "UnionId" : this.props.unionid,
      "ClubId" : this.props.clubid,
      "Remarks" : this.state.Remarks,
      "Captcha" : this.state.Captcha,
      "UnionMember": this.state.isUnionMember,
      "Preferences" : {
         "PrivacyTermsAccepted" : (this.state.isUnionMember && !this.state.minor),
         "PrivacyTermsClubAccepted" : !this.state.minor,
         "Newsletters" : false,
         "MarketingData" : false
       }
     };


    const allData = Object.assign(
        baseData,
        this.personDataForm.getFormValues(),
        this.activityDataForm.getFormValues(),
        {  "Address" : this.addressDataForm.getFormValues()},
        { "Communication" :  this.commDataForm.getFormValues()},
        { "FreeField": this.freeFieldDataForm.getFormValues()},
        { "Financial": this.financialDataForm.getFormValues()}
      );
    return allData;
  }


  handleSubmit(event) {
    event.preventDefault();

    if (this.checkAndFocusValidationError(this.activityDataForm)) return;
    if (this.checkAndFocusValidationError(this.personDataForm)) return;
    if (this.checkAndFocusValidationError(this.addressDataForm)) return;
    if (this.checkAndFocusValidationError(this.commDataForm)) return;
    if (this.checkAndFocusValidationError(this.freeFieldDataForm)) return;
    if (this.checkAndFocusValidationError(this.financialDataForm)) return;

    // My own errors?
    if (this.checkAndFocusMyValidationError()) return;

    var formValues = this.getFormValues()
    this.validate = true;

    this.props.submittingForm()
    entityPost("Registration", formValues, this.props.submitFormSuccess, this.props.submitFormFailure);
    return false;
  }


  checkAndFocusValidationError(obj) {
    var validations = obj.runValidations(true);
    var firstError = Object.keys(validations)[0]
    if (firstError) {
      if (obj[firstError]) obj[firstError].focus();
      return true;
    }
    return false;
  }

  checkAndFocusMyValidationError(errors) {
    var firstError = Object.keys(this.state.validationErrors)[0]
    if (firstError) {
      if (this[firstError]) this[firstError].focus();
      return true;
    }
    return false;
  }

  render() {
    if (this.props.registration.failure ) {
      return <DataFetchError />;
    } else if (this.props.registration.fetchers > 0) {
      return <Loading />;
    } else if (!this.props.registration.club.PrivacyStatementClub) {
      return <MissingPrivacyStatement clubName={this.props.clubName} />
    } else if (this.props.registration.formSubmitSuccess) {
      return <RegistrationSuccess minor={this.state.minor} clubName={this.props.clubName} />
    }
    return (
      <Form onSubmit={this.handleSubmit} autoComplete="off">
        <ConfirmNoSports clubName={this.props.clubName} isOpen={this.state.confirmNoSports} cancelToggle={() => this.setState({confirmNoSports: false})} continueToggle={this.handleSubmit}/>
        <SubmitFailure clubName={this.props.clubName} isOpen={this.props.registration.formSubmitFailure} toggle={this.clearSubmitFailure}/>

          <Row>
            <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
              <RegistrationFormActivityData
                ref={instance => { this.activityDataForm = instance; }}
                unionSport = {this.props.registration.club.UnionSport}
                clubSport = {this.props.registration.club.ClubSport}
                isUnionMember={this.state.isUnionMember}
                setIsUnionMember={this.setIsUnionMember}
                unionid={this.props.unionid}
                clubName={this.props.clubName}
                />
            </Col>
          </Row>


        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
            <RegistrationFormPersonData
              ref={instance => { this.personDataForm = instance; }}
              setIsMinor={this.setIsMinor}
              nationalities={this.props.registration.nationalities}
             />
          </Col>
        </Row>

        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
            <RegistrationFormAddressData
              ref={instance => { this.addressDataForm = instance; }}
              countries={this.props.registration.countries}
              />

          </Col>
        </Row>

        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
          <RegistrationForCommData
            ref={instance => { this.commDataForm = instance; }}
            minor={this.state.minor}
            clubName={this.props.clubName}
            />
          </Col>
        </Row>

{/* For now this option has been turned off. Wait for something magical to happen. So just always hide the shit
        <Row hidden={!this.props.registration.club.FreeField.DescriptionFreeDropDown1 && !this.props.registration.club.FreeField.DescriptionFreeDropDown2}>
*/}
<Row hidden={true}>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
          <RegistrationFormFreeFieldData
            ref={instance => { this.freeFieldDataForm = instance; }}
            minor={this.state.minor}
            freeFieldData={this.props.registration.club.FreeField}
            />
          </Col>
        </Row>

        <Row hidden={!this.props.registration.club.IsPreferredPaymentMethodDirectDebit}>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
            <RegistrationFormFinancialData
              ref={instance => { this.financialDataForm = instance; }}
              />
          </Col>
        </Row>

        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
            <Container>
              <h2 className="TextCenter">
                Opmerkingen
              </h2>

                <Row>
                  <p>
                    Heb je voorkeuren voor de spelvorm, het team waar je graag in zou willen spelen of iets anders dat
                    je aan de ledenadministrateur van {this.props.clubName}  wilt meegeven? Geef dat dan hieronder aan.
                  </p>
                </Row>

                <Row>
                  <FormGroup className="CommentsFormGroup">
                    <Input name="Remarks"
                      type="textarea"
                      value={this.state.Remarks}
                      onChange={this.handleChange}
                      onBlur={this.setFieldsTouched}
                      innerRef={(input) => { this.Remarks = input; }}
                      invalid={this.checkInvalid("Remarks")}
                      className="InputRemarks" />
                    <FormFeedback>{this.errorFor("Remarks")}</FormFeedback>
                  </FormGroup>
                </Row>
              </Container>
          </Col>
        </Row>

        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup borderGroup" >
            <Container>
              <h2 className="TextCenter">
                Privacyverklaringen
              </h2>
              <Row hidden={this.state.isUnionMember}>
                <p>
                  Lees de onderstaande privacyverklaring van {this.props.clubName} goed door voordat je je aanmeldt.
                  In deze verklaring staat hoe {this.props.clubName} omgaan met persoonsgegevens.
                </p>
              </Row>
              <Row hidden={!this.state.isUnionMember}>
                <p>
                  Lees de onderstaande privacyverklaringen van {this.props.clubName} en de {this.props.unionid} goed door voordat je je aanmeldt.
                  In deze verklaringen staat hoe {this.props.clubName} en de {this.props.unionid} omgaan met persoonsgegevens.
                </p>
              </Row>
              <Row hidden={!this.state.isUnionMember}>
                <p>
                  <a href={this.props.registration.club.PrivacyStatementUnion} target="_blank">  Privacyverklaring {this.props.unionid} </a>
                </p>
              </Row>
              <Row>
                <p>
                  <a href={this.props.registration.club.PrivacyStatementClub}  target="_blank">  Privacyverklaring {this.props.clubName} </a>
                </p>
              </Row>
              <Row>
                <Col md={{size:4, offset:4}} >
                  {/* Input to support focus() on validation error */}
                  <Input
                    name="CaptchaFocus"
                    type="text"
                    hidden={true}
                    innerRef={(input) => { this.Captcha = input; }}
                    />
                  <ReCAPTCHA
                    className={this.checkInvalid("Captcha") ? "form-control is-invalid" : ""}
                     sitekey="6LfzsVYUAAAAAL5_z7-8zBPxNjKsXNmPubQRVIy4"
                     onChange={this.onCaptchaChange}
                    />
                  <FormFeedback>{this.errorFor("Captcha")}</FormFeedback>
                </Col>

              </Row>

              <Row>
                <Col md={{size:3, offset:9}} >

                  <Button type="submit"
                    disabled={this.props.registration.submitting}
                    className="formSubmit" >
                      Aanmelden
                  </Button>
                </Col>
              </Row>
          </Container>
        </Col>
      </Row>
    </Form>
    );
  }
}
RegistrationForm.propTypes = {
  clubName: PropTypes.string,
}

const mapStateToProps = state => ({
  registration : state.registration,
  clubName: state.registration.club.Name
})

const mapDispatchToProps = dispatch => ({
  fetchingCountries: () => dispatch(Actions.fetchingCountries()),
  fetchCountriesSuccess: (data) => dispatch(Actions.fetchCountriesSuccess(data['CountryCodes'])),
  fetchCountriesFailure: () => dispatch(Actions.fetchCountriesFailure()),

  fetchingNationalities: () => dispatch(Actions.fetchingNationalities()),
  fetchNationalitiesSuccess: (data) => dispatch(Actions.fetchNationalitiesSuccess(data['Nationalities'])),
  fetchNationalitiesFailure: () => dispatch(Actions.fetchNationalitiesFailure()),

  submittingForm: () => dispatch(Actions.submittingForm()),
  submitFormSuccess: (data) => dispatch(Actions.submitFormSuccess(data)),
  submitFormFailure: (data) => dispatch(Actions.submitFormFailure(data)),

  clearSubmitFailure: () => dispatch(Actions.clearSubmitFailure())

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationForm)



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationForm.jsx